import { render, staticRenderFns } from "./PracticeDefine.vue?vue&type=template&id=7262b274&"
import script from "./PracticeDefine.vue?vue&type=script&lang=js&"
export * from "./PracticeDefine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports